import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { getReportsSelector } from '../../../../../../../../redux/reducers/reducerSlices/ReportsReducerSlice';
import { AppConstant } from "../../../../../../../Assests/AppConstant";
import DrilldownTableBody from '../../../../Dashboard/DefaultDashboard/DrillDownReports/Common/DrilldownTableBody';
import { getDate, getTime } from "../../../../../../../../Utils/DateUtils";
import { sagaActions } from '../../../../../../../../sagas/sagaActions';


const GateCheckReportList = (props) => {

    const dispatch = useDispatch();
    const { themeSelected, isLoading } = props;
    const reportsSelector = useSelector(getReportsSelector);
    const { gateCheckReport, initateLoading } = reportsSelector;
    const [gateCheckReportArr, setGateCheckReportArr] = useState([]);

    const gateCheckReportTitleDD = [
        { id: 'Carrier', name: AppConstant.reports.gateCheckReport.tableHeaders.carrier },
        { id: 'DriverName', name: AppConstant.reports.gateCheckReport.tableHeaders.driverName },
        { id: 'TruckNum', name: AppConstant.reports.gateCheckReport.tableHeaders.truckNum },
        { id: 'TrailerNum', name: AppConstant.reports.gateCheckReport.tableHeaders.trailerNum },
        { id: 'POs', name: AppConstant.reports.gateCheckReport.tableHeaders.pos },
        { id: 'Door', name: AppConstant.reports.gateCheckReport.tableHeaders.door },
        { id: 'ControlNo', name: AppConstant.reports.gateCheckReport.tableHeaders.controlNo },
        { id: 'ScheduledDate', name: AppConstant.reports.gateCheckReport.tableHeaders.scheduedDate },
        { id: 'ScheduledTime', name: AppConstant.reports.gateCheckReport.tableHeaders.scheduedTime },
        { id: 'GateInTime', name: AppConstant.reports.gateCheckReport.tableHeaders.gateInTime },
        { id: 'Bills to Driver', name: AppConstant.reports.gateCheckReport.tableHeaders.b2d },
        { id: 'GateOutTime', name: AppConstant.reports.gateCheckReport.tableHeaders.gateOutTime },
    ]


    useEffect(() => {
        if (gateCheckReport && gateCheckReport?.length) {
            setGateCheckReportArr(gateCheckReport);
            setTimeout(()=>{
            dispatch({ type: sagaActions.INTIATE_LOADER_REPORTS, payload: false })
            },500)
        }
    }, [gateCheckReport])

    const formatListDataDrillDown = (data) => {
        return data.map((el, index) => {
            return {
                id: index,
                0: el.Carrier ? el.Carrier : '-',
                1: el.driverName ? el.driverName : '-',
                2: el.tractor ? el.tractor : '-',
                3: el.trailer ? el.trailer : '-',
                4: el.POs ? el.POs : '-',
                5: el.door ? el.door : '-',
                6: el.Control ? el.Control : '-',
                7: el.scheduledtime ? getDate(el.scheduledtime) : '-',
                8: el.scheduledtime ? getTime(el.scheduledtime) : '-',
                9: el.checkInTime ? el.checkInTime : '-',
                10: el.OutDoorTime ? el.OutDoorTime : '-',
                11:el.gateOutTime ? el.gateOutTime : '-',
            }
        })
    }

    return (
        <div className="mx-2 py-2">
            
            <table className="m-0 p-0 table table-responsive table-hover">
                <thead>
                    <tr className={`text-center align-middle ${themeSelected} truck-list-title`}>
                        {
                            gateCheckReportTitleDD.map((el) => {
                                return (
                                    <th colSpan={el.colSpan} scope="col" className={`col px-0 ${themeSelected} title-text-container `} id={el.id} key={el.id}>
                                        <span className='text-center'>{el.name}</span>
                                    </th>
                                )
                            })
                        }
                    </tr>
                </thead>
                <DrilldownTableBody
                    themeSelected={themeSelected}
                    data={gateCheckReportArr && gateCheckReportArr && formatListDataDrillDown(gateCheckReportArr)}
                    showCollapse={false}
                    showInput={false}
                    showSort={false}
                    initiateDrillDownReport={initateLoading}
                    loaderArray={12}
                    sortKey={true}
                    showUTCTime={true}
                />
            </table>
        </div>
    )
}

export default GateCheckReportList